var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.table)?_c('div',{staticClass:"view"},[_c('vBreadcrumb',{attrs:{"items":_vm.breadcrumb}}),_c('page',_vm._b({key:_vm.viewKey},'page',[{tableId: _vm.tableId, requests: _vm.requests}],false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }